(() => {
  const init = () => {
    const toc = document.querySelector('[data-sp-toc]');
    if (!toc) return false;

    const toggle = toc.querySelector('[data-sp-toc-toggle]');
    const linksWrap = toc.querySelector('[data-sp-toc-links]');
    if (!linksWrap) return false;

    const links = Array.from(linksWrap.querySelectorAll('a[href^="#"]'));
    const targets = links
      .map(a => document.querySelector(a.getAttribute('href')))
      .filter(Boolean);

    if (!links.length || !targets.length) return false;

    // Mobile toggle
    if (toggle) {
      toggle.addEventListener('click', () => {
        const open = toc.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }

    // Smooth scroll (theme-safe, avoids double-jumps)
    links.forEach(a => {
      a.addEventListener('click', (e) => {
        const id = a.getAttribute('href');
        const el = document.querySelector(id);
        if (!el) return;
        e.preventDefault();
        toc.classList.remove('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', id);
      });
    });

    // Active highlight via IntersectionObserver
    const setActive = (id) => {
      links.forEach(a => {
        const active = a.getAttribute('href') === id;
        a.classList.toggle('is-active', active);
      });
    };

    const obs = new IntersectionObserver(
      (entries) => {
        // pick the most visible section
        const visible = entries
          .filter(e => e.isIntersecting)
          .sort((a, b) => (b.intersectionRatio - a.intersectionRatio))[0];
        if (!visible) return;
        setActive(`#${visible.target.id}`);
      },
      { root: null, threshold: [0.2, 0.35, 0.5, 0.65], rootMargin: "-15% 0px -60% 0px" }
    );

    targets.forEach(t => obs.observe(t));

    // Initial state
    const initial = location.hash && document.querySelector(location.hash) ? location.hash : `#${targets[0]?.id || ''}`;
    if (initial) setActive(initial);
    return true;
  };

  const ready = () => {
    let attempts = 0;
    const tryInit = () => {
      if (init()) return;
      attempts += 1;
      if (attempts < 20) setTimeout(tryInit, 200);
    };
    tryInit();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();

